import styled from 'styled-components';

export const StyledIconWrapper = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background-color: var(--brand-1);
    border-radius: 8px;
    width: 32px;
    height: 32px;
    color: var(--brand-6);
    font-size: 20px;
`;
